import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=5f68d56b&scoped=true&"
import script from "./NotFound.vue?vue&type=script&lang=js&"
export * from "./NotFound.vue?vue&type=script&lang=js&"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=5f68d56b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f68d56b",
  null
  
)

/* custom blocks */
import block0 from "./NotFound.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(component)

export default component.exports